import { useQuery } from '@tanstack/react-query';
import { EleveGroup } from '@teetsh/app/src/types/eleveGroups';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

export const ELEVE_GROUPS_KEY = 'eleveGroups';

export function useEleveGroups(enabled = true) {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery<EleveGroup[]>({
    queryKey: [schoolyear.id, school.id, ELEVE_GROUPS_KEY],
    queryFn: () =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleve-groups`,
        {
          method: 'GET',
        },
      ).then(({ data }) => data || []),
    enabled,
  });
}
